<template>
  <div class="header_wrapper" :class="{ scrolled, 'past-hero': pastHero, solid: !isHome, 'is-compact': compact }" ref="headerReveal">
    <div class="connection">
      <div class="connection_left">
        <a href="mailto:nazorat@trm.uz" class="connection_left_email">
          <img src="../../assets/img/logos/email.svg" alt="email" />
          <p>nazorat@trm.uz</p>
        </a>
        <a href="tel:+998555190202" class="connection_left_phone">
          <img src="../../assets/img/logos/phone.svg" alt="" />
          <p>+998(55)519-02-02</p>
        </a>
      </div>
      <div class="connection_marquee" aria-hidden="true">
        <div class="connection_marquee_track">
          <span>{{ $t('common.testMode') }}</span>
          <span>{{ $t('common.testMode') }}</span>
          <span>{{ $t('common.testMode') }}</span>
          <span>{{ $t('common.testMode') }}</span>
        </div>
      </div>
      <div class="connection_right">
        <div class="connection_right_socials">
          <ul>
            <li>
              <a href="https://t.me/trm_uz" target="_blank" rel="noopener" aria-label="Telegram">
                <img src="../../assets/img/logos/tg.svg" alt="Telegram" />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/trm_uz" target="_blank" rel="noopener" aria-label="Instagram">
                <img src="../../assets/img/logos/insta.svg" alt="Instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/trmuz/" target="_blank" rel="noopener" aria-label="Facebook">
                <img src="../../assets/img/logos/facebook.svg" alt="Facebook" />
              </a>
            </li>
            <li>
              <a href="https://www.youtube.com/@trm_uz" target="_blank" rel="noopener" aria-label="YouTube">
                <img src="../../assets/img/logos/youtube.svg" alt="YouTube" />
              </a>
            </li>
          </ul>
        </div>
        <img src="../../assets/img/logos/small_divider.png" alt="divider" />
        <div class="connection_right_disabled">
          <ul>
            <li @click="openA11y" style="cursor: pointer" :title="$t('a11y.title')"><img src="../../assets/img/logos/sound.svg" alt="ovoz" /></li>
            <li @click="openA11y" style="cursor: pointer" :title="$t('a11y.title')"><img src="../../assets/img/logos/view.svg" :alt="$t('a11y.title')" /></li>
          </ul>
        </div>
        <img src="../../assets/img/logos/small_divider.png" alt="divider" />

        <div class="connection_right_language" ref="langBox" :class="{ open: langOpen }">
          <button
            type="button"
            class="lang-trigger"
            ref="langTrigger"
            :aria-label="$t('common.language')"
            aria-haspopup="listbox"
            :aria-expanded="langOpen ? 'true' : 'false'"
            @click="toggleLang"
          >
            <img class="lang-flag" :src="flagFor(locale)" alt="" />
            <span class="lang-current">{{ currentLocale.short }}</span>
            <img class="lang-caret" src="../../assets/img/logos/arrow_down.svg" alt="" />
          </button>
          <!-- Teleported to <body> so the top-bar's overflow:hidden and the
               transformed header wrapper can't clip the dropdown. -->
          <teleport to="body">
            <ul v-show="langOpen" class="lang-menu" role="listbox" ref="langMenu" :style="menuStyle">
              <li v-for="l in locales" :key="l.code" role="option" :aria-selected="l.code === locale ? 'true' : 'false'">
                <button
                  type="button"
                  class="lang-option"
                  :class="{ 'lang-option--active': l.code === locale }"
                  @click="chooseLang(l.code)"
                ><img class="lang-option__flag" :src="flagFor(l.code)" alt="" />{{ l.name }}</button>
              </li>
            </ul>
          </teleport>
        </div>
      </div>
    </div>
    <img
      src="../../assets/img/logos/Divider.png"
      alt=""
    />
    <div class="header_container">
      <div class="header_container_left">
        <div class="gerb_logo">
          <img src="../../assets/img/logos/uzb_gerb.png" :alt="$t('common.gerbAlt')" />
        </div>
        <span class="forline" aria-hidden="true"></span>
        <div class="markaz_name">
          <router-link to="/" class="txt">
            {{ $t('common.orgName') }}
          </router-link>
        </div>
      </div>
      <div class="header_container_right">
        <div class="navigation_panel">
          <ul>
            <li class="markaz_dropdown">
              <div class="together">
                {{ $t('nav.markaz') }}
                <img src="../../assets/img/logos/Vector.png" alt="" />
              </div>
              <ul class="markaz_dropdown_menu">
                <li>
                  <router-link to="/markaz/markaz-haqida">{{ $t('nav.markazHaqida') }}</router-link>
                </li>
                <li>
                  <router-link to="/markaz/rahbariyat">{{ $t('nav.rahbariyat') }}</router-link>
                </li>
                <li>
                  <router-link to="/markaz/boshqarma-boshliqlari">{{ $t('nav.boshqarmaBoshliqlari') }}</router-link>
                </li>
                <li><router-link to="/markaz/tuzilma">{{ $t('nav.tuzilma') }}</router-link></li>
              </ul>
            </li>
            <li class="faoliyat_dropdown">
              <div class="together">
                {{ $t('nav.faoliyat') }}
                <img src="../../assets/img/logos/Vector.png" alt="" />
              </div>
              <ul class="faoliyat_dropdown_menu">
                <li>
                  <router-link to="/faoliyat/oquv-metodik">{{ $t('nav.oquvMetodik') }}</router-link>
                </li>
                <li>
                  <router-link to="/faoliyat/talim-normativlari">{{ $t('nav.talimNormativlari') }}</router-link>
                </li>
                <li>
                  <router-link to="/faoliyat/baholash-monitoring">{{ $t('nav.baholashMonitoring') }}</router-link>
                </li>
                <li>
                  <router-link to="/faoliyat/raqamli-savodxonlik">{{ $t('nav.raqamliSavodxonlik') }}</router-link>
                </li>
                <!-- Nested flyout: its own section, but reached from Faoliyat.
                     Opens to the right, or to the left when there's no room. -->
                <li class="has-sub" :class="{ 'has-sub--flip': subFlip }" @mouseenter="placeSub">
                  <router-link to="/ilmiy-metodik" class="sub-trigger">
                    {{ $t('nav.ilmiyMetodik') }}
                    <svg class="sub-trigger__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
                  </router-link>
                  <ul class="sub-menu">
                    <li v-for="it in ilmiyNav" :key="it.to">
                      <router-link :to="it.to">
                        {{ $t(it.labelKey) }}
                        <span v-if="it.soon" class="nav-soon">{{ $t('common.soon') }}</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li>
                  <router-link to="/faoliyat/hisobotlar">{{ $t('nav.hisobotlar') }}</router-link>
                </li>
              </ul>
            </li>
            <li class="hujjatlar_dropdown">
              <div class="together">
                {{ $t('nav.hujjatlar') }}
                <img src="../../assets/img/logos/Vector.png" alt="" />
              </div>
              <ul class="hujjatlar_dropdown_menu">
                <li>
                  <router-link to="/hujjatlar/talimga-oid">{{ $t('nav.talimgaOidQonunlar') }}</router-link>
                </li>
                <li>
                  <router-link to="/hujjatlar/prezident-farmonlari">{{ $t('nav.prezidentFarmonlari') }}</router-link>
                </li>
                <li>
                  <router-link to="/hujjatlar/vazirlar-mahkamasi">{{ $t('nav.vazirlarMahkamasi') }}</router-link>
                </li>
                <li>
                  <router-link to="/hujjatlar/markaz-faoliyati">{{ $t('nav.markazFaoliyati') }}</router-link>
                </li>
              </ul>
            </li>
            <li class="axborot_dropdown">
              <div class="together">
                {{ $t('nav.axborot') }}
                <img src="../../assets/img/logos/Vector.png" alt="" />
              </div>
              <ul class="axborot_dropdown_menu">
                <li>
                  <router-link to="/axborot/savol-javob">{{ $t('nav.savolJavob') }}</router-link>
                </li>
                <li>
                  <router-link to="/axborot/ochiq-malumotlar">{{ $t('nav.ochiqMalumotlar') }}</router-link>
                </li>
                <li>
                  <router-link to="/axborot/yangiliklar">{{ $t('nav.yangiliklar') }}</router-link>
                </li>
                <li>
                  <router-link to="/axborot/galereya">{{ $t('nav.galereya') }}</router-link>
                </li>
              </ul>
            </li>
            <li><router-link to="/pisa">{{ $t('nav.pisa') }}</router-link></li>
            <li><router-link to="/boglanish">{{ $t('nav.boglanish') }}</router-link></li>
          </ul>
        </div>
      </div>
      <!-- ── Mobile only: hamburger sits to the right of the org name (hidden ≥ breakpoint) ── -->
      <button class="mnav-fab" type="button" :aria-label="$t('common.menu')" @click="mobileOpen = true">
        <span></span><span></span><span></span>
      </button>
    </div>

  <teleport to="body">
    <transition name="mnav">
      <div v-if="mobileOpen" class="mnav" @click.self="mobileOpen = false">
        <div class="mnav__sheet">
          <div class="mnav__top">
            <div class="mnav__org">
              <img class="mnav__gerb" src="../../assets/img/logos/uzb_gerb.png" alt="Gerb" />
              <span class="mnav__orgname">{{ $t('common.orgName') }}</span>
            </div>
            <button class="mnav__x" type="button" :aria-label="$t('a11y.close')" @click="mobileOpen = false">&times;</button>
          </div>
          <h3 class="mnav__title">{{ $t('common.menu') }}</h3>
          <ul class="mnav__list">
            <li v-for="(sec, i) in mobileSections" :key="i" class="mnav__sec" :class="{ 'mnav__sec--open': openSec === i }">
              <button class="mnav__sec-head" type="button" @click="openSec = openSec === i ? -1 : i">
                <span>{{ $t(sec.titleKey) }}</span>
                <img class="mnav__chev" src="../../assets/img/logos/arrow_down.svg" alt="" />
              </button>
              <div class="mnav__collapse">
                <ul class="mnav__sub">
                  <li v-for="it in sec.items" :key="it.to">
                    <router-link :to="it.to" @click="mobileOpen = false">{{ $t(it.labelKey) }}<span v-if="it.soon" class="nav-soon">{{ $t('common.soon') }}</span></router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li class="mnav__sec">
              <router-link class="mnav__sec-head mnav__sec-head--link" to="/pisa" @click="mobileOpen = false">{{ $t('nav.pisa') }}</router-link>
            </li>
            <li class="mnav__sec mnav__sec--contact">
              <router-link class="mnav__sec-head mnav__sec-head--link" to="/boglanish" @click="mobileOpen = false">{{ $t('nav.boglanish') }}</router-link>
              <a class="mnav__contact" href="mailto:nazorat@trm.uz">
                <img src="../../assets/img/logos/email.svg" alt="" />
                <span>nazorat@trm.uz</span>
              </a>
              <a class="mnav__contact" href="tel:+998555190202">
                <img src="../../assets/img/logos/phone.svg" alt="" />
                <span>+998 (55) 519-02-02</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </teleport>
  </div>
</template>

<script>
import { ui } from '../../accessibility/state'
import { LOCALES, getLocale, setLocale, langForLocale } from '../../i18n'
import { markazNav, faoliyatNav, ilmiyNav, hujjatlarNav, axborotNav } from '../../data/sideNavs'
import { useScrollReveal } from '../../composables/useScrollReveal'
import uzFlag  from '../../assets/img/logos/uz-flag.png'
import rusFlag from '../../assets/img/logos/rus-flag.png'
import engFlag from '../../assets/img/logos/eng-flag.jpg'

// Both Uzbek scripts share the Uzbek flag.
const LANG_FLAGS = { 'uz-Latn': uzFlag, ru: rusFlag, en: engFlag }

export default {
  setup() {
    // Header sits at the top, so its trigger fires immediately → fade-in on load.
    const headerReveal = useScrollReveal({ animation: 'fade-in', duration: 0.6 })
    return { headerReveal }
  },
  data() {
    return {
      scrolled: false, pastHero: false, langOpen: false, locales: LOCALES, menuStyle: {},
      compact: false, lastScrollY: 0, idleTimer: null,
      mobileOpen: false,
      openSec: 0,
      ilmiyNav,
      subFlip: false,
      mobileSections: [
        { titleKey: 'nav.markaz', items: markazNav },
        // Ilmiy-metodik gets its own section below, so skip its Faoliyat entry here
        { titleKey: 'nav.faoliyat', items: faoliyatNav.filter((it) => it.to !== '/ilmiy-metodik') },
        { titleKey: 'nav.ilmiyMetodik', items: ilmiyNav },
        { titleKey: 'nav.hujjatlar', items: hujjatlarNav },
        { titleKey: 'nav.axborot', items: axborotNav }
      ]
    }
  },
  computed: {
    // home page has the building hero behind a transparent header; every other
    // route has no hero, so the header starts solid white there.
    isHome() {
      // By name, not by path: the home page is /uz, /ru or /en, never bare "/".
      return this.$route.name === 'home'
    },
    locale() {
      return getLocale()
    },
    currentLocale() {
      return LOCALES.find(l => l.code === this.locale) || LOCALES[0]
    }
  },
  watch: {
    // close menus whenever the user navigates
    $route() {
      this.langOpen = false
      this.mobileOpen = false
    },
    // lock background scroll while the mobile menu is open
    mobileOpen(v) {
      document.body.style.overflow = v ? 'hidden' : ''
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    window.addEventListener('resize', this.closeLang)
    document.addEventListener('click', this.onDocClick)
    document.addEventListener('keydown', this.onKeydown)
    this.onScroll()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.closeLang)
    document.removeEventListener('click', this.onDocClick)
    document.removeEventListener('keydown', this.onKeydown)
    clearTimeout(this.idleTimer)
  },
  methods: {
    flagFor(code) {
      return LANG_FLAGS[code] || uzFlag
    },
    // Flip the Ilmiy-metodik flyout to the left when it would run off-screen.
    placeSub(e) {
      const li = e.currentTarget
      const sub = li.querySelector('.sub-menu')
      if (!sub) return
      this.subFlip = li.getBoundingClientRect().right + sub.offsetWidth > window.innerWidth - 8
    },
    openA11y() {
      ui.open = true
    },
    toggleLang() {
      this.langOpen = !this.langOpen
      if (this.langOpen) this.$nextTick(this.positionMenu)
    },
    closeLang() {
      this.langOpen = false
    },
    positionMenu() {
      const t = this.$refs.langTrigger
      if (!t) return
      const r = t.getBoundingClientRect()
      this.menuStyle = {
        position: 'fixed',
        top: `${Math.round(r.bottom + 8)}px`,
        right: `${Math.round(Math.max(8, window.innerWidth - r.right))}px`
      }
    },
    chooseLang(code) {
      // Remembered, unlike a language that came from following a link.
      setLocale(code)
      this.langOpen = false
      // Keep the address bar honest: the prefix is what makes a copied link
      // open in this language for the next reader. Switching between the two
      // Uzbek scripts leaves the URL alone — they share /uz.
      const lang = langForLocale(code)
      if (lang !== this.$route.params.lang) {
        this.$router.replace({
          path: `/${lang}${this.$route.path.replace(/^\/(uz|ru|en)(?=\/|$)/, '')}`,
          query: this.$route.query,
          hash: this.$route.hash
        })
      }
    },
    onDocClick(e) {
      const box = this.$refs.langBox
      const menu = this.$refs.langMenu
      if (
        this.langOpen &&
        box && !box.contains(e.target) &&
        (!menu || !menu.contains(e.target))
      ) {
        this.langOpen = false
      }
    },
    onKeydown(e) {
      if (e.key === 'Escape') this.langOpen = false
    },
    onScroll() {
      if (this.langOpen) this.langOpen = false
      const y = window.scrollY
      this.scrolled = y > 50
      // Header reveal (mobile + desktop): scroll up → full header; scroll down →
      // collapse to the lower part only. After 3s of no scrolling (and not at the
      // top), it collapses back to the half header on its own.
      clearTimeout(this.idleTimer)
      if (y <= 10) {
        this.compact = false           // at the very top → always full
      } else if (y > this.lastScrollY + 4) {
        this.compact = true            // scrolling down → collapse
      } else if (y < this.lastScrollY - 4) {
        this.compact = false           // scrolling up → reveal the upper part
      }
      // collapse 3s after scrolling stops (unless at the top or the lang menu is open)
      this.idleTimer = setTimeout(() => {
        if (window.scrollY > 10 && !this.langOpen) this.compact = true
      }, 3000)
      this.lastScrollY = y
      // white header only after the building.png hero has scrolled past the header
      const hero = document.querySelector('.main-page .container')
      this.pastHero = hero
        ? hero.getBoundingClientRect().bottom <= this.$el.offsetHeight
        : false
    }
  }
}
</script>

<style lang="scss">
@import "../../styles/components/01main/header.scss";
</style>